export default {
  LEADS_OVERVIEW: 'Präsentation der vooruitzichten',
  TOTAL_LEADS: 'Aantal totale vooruitzichten',
  HOT_LEADS: 'Pista calda',
  WARM_LEADS: 'Des pistas chaleureuses',
  COLD_LEADS: 'De pistas de froides',
  NO_RECORDS_FOUND: 'Nessuna descrizione trovata',
  DETAILS: 'Details',
  CATEGORY: 'Kategorie',
  SCAN_DATE_N_TIME: 'Fecha en hora de numeración',
  FILTER: 'filtern',
  ALL: 'Eeeek!!!',
  HOT: 'Caldo',
  WARM: 'Caldo',
  COLD: 'Froide',
  SELECT_DATES: 'Termine auswählen',
  SEARCH_LEADS: 'Suche nach Leads',
  SCANNED_BY: 'gescannt von',
  FILES_INFO_SHARED: 'Gemeinsame Nutzung von Dateien und Informationen',
  IMAGES: 'Bilder',
  NOTE: 'Notiz',
  DELETED_FILE_MSG: 'Diese Datei wurde gelöscht',
  LEAD_DETAILS: 'Lead-Details',
  ANONYMISE_DAYS: 'Die Lead-Details werden innerhalb von {days} Tagen anonymisiert.'
}
